import React from 'react';
import { CustomerBillingAddressContract } from '../../../types/Customer';
import { AddressFormData } from '../../../types/Address';
import AddressSummary from '../../summary/AddressSummary';
import SectionSummary, {
  SectionSummaryGroupPosition,
} from '../../summary/SectionSummary';

type EditableBillingAddressSectionProps = {
  disallowEdit?: never;
  onBillToInfoEdit: () => void;
};

type ReadOnlyBillingAddressSectionProps = {
  disallowEdit: true;
  onBillToInfoEdit?: never;
};

export type AuthenticatedBillingAddressSectionBaseProps = {
  billingAddress: CustomerBillingAddressContract | null;
  displaySameAsShipping: boolean;
  groupPosition?: SectionSummaryGroupPosition;
};

export type AuthenticatedBillingAddressSectionProps =
  AuthenticatedBillingAddressSectionBaseProps &
    (EditableBillingAddressSectionProps | ReadOnlyBillingAddressSectionProps);

const AuthenticatedBillingAddressSection: React.FC<
  AuthenticatedBillingAddressSectionProps
> = ({
  billingAddress,
  disallowEdit,
  displaySameAsShipping,
  groupPosition,
  onBillToInfoEdit,
}: AuthenticatedBillingAddressSectionProps) => {
  if (billingAddress === null) {
    return null;
  }
  const addressContent = billingAddress?.address1 ? (
    <AddressSummary address={billingAddress as AddressFormData} />
  ) : (
    'No saved addresses'
  );
  const contentToDisplay = displaySameAsShipping
    ? 'Same address as shipping'
    : addressContent;
  return disallowEdit ? (
    <SectionSummary
      title="Bill To"
      content={contentToDisplay}
      groupPosition={groupPosition}
      toolTipKey="AuthenticatedBillingAddressKey"
      linkButtonDataTestId="LinkButton-input-BillingAddress-Summary"
    />
  ) : (
    <SectionSummary
      title="Bill To"
      content={contentToDisplay}
      displayActionButton
      actionButtonText="Edit"
      onActionButtonClicked={onBillToInfoEdit}
      groupPosition={groupPosition}
      toolTipKey="AuthenticatedBillingAddressKey"
      linkButtonDataTestId="LinkButton-input-BillingAddress-Summary"
    />
  );
};

export default AuthenticatedBillingAddressSection;
